import { Stepper as MuiStepper, Step, StepLabel, StepConnector, Typography, Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

import { ReactComponent as StepIconBase } from '../icons/check-completed-icon.svg'

interface StepObject {
  label: string
  description: string
}

interface OwnershipTransferStepperProps {
  activeStep: number
  steps: StepObject[]
}

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  alternativeLabel: {
    top: 10,
  },
  active: {
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.primary.main,
    },
  },
  completed: {
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.primary.main,
    },
  },
  line: {
    borderTopWidth: 2,
    borderColor: theme.palette.grey[400],
  },
}))

function CustomStepIconWrapper(active: boolean, completed: boolean) {
  return function StepIcon(props: any) {
    return <CustomStepIcon active={active} completed={completed} {...props} />
  }
}

function CustomStepIcon({ active, completed }: { active: boolean; completed: boolean }) {
  const StepIconStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 21,
    height: 21,
    borderRadius: '50%',
    border: 'solid 4px',
    borderColor: active ? 'secondary.50' : 'transparent',
  }

  return completed ? (
    <Box sx={StepIconStyle}>
      <StepIconBase fill="primary.main" height="8px" />
    </Box>
  ) : (
    <Box sx={StepIconStyle}>
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: active ? 'primary.main' : 'grey.200' }} />
    </Box>
  )
}

function Stepper({ activeStep, steps }: OwnershipTransferStepperProps) {
  return (
    <MuiStepper
      alternativeLabel
      activeStep={activeStep}
      connector={<CustomConnector />}
      sx={{ margin: 'auto', width: '80%' }}
    >
      {steps.map((step, index) => (
        <Step key={index} completed={activeStep > index}>
          <StepLabel StepIconComponent={CustomStepIconWrapper(activeStep === index, activeStep > index)}>
            <Typography variant="body1" color="primary.700">
              {step.label}
            </Typography>
            {step.description && (
              <Typography variant="caption" color="primary.600">
                {step.description}
              </Typography>
            )}
          </StepLabel>
        </Step>
      ))}
    </MuiStepper>
  )
}

export default Stepper
